/**
 * TODO -- Move the InlineNotification to dorado
 */
import { ReactElement, useEffect } from 'react';

import { useCheckoutState, useCheckoutAPI } from '~/hooks/checkout';
import { GLOBAL_ERROR_NAME, CHECKOUT_ERRORS } from '~/constants/checkout';

import { InlineNotification } from '../../common/InlineNotification';

export function ErrorNotification({
  redirectPaymentError,
}: Readonly<{
  redirectPaymentError: boolean;
}>): ReactElement {
  const { stepErrorMessageObject } = useCheckoutState();
  const { setStepErrorMessage } = useCheckoutAPI();

  // redirectPaymentError is set from the intitialProps on the "page", does not need to update
  // Without the useEffect this will infinitely loop
  useEffect(() => {
    if (redirectPaymentError) {
      setStepErrorMessage(GLOBAL_ERROR_NAME, CHECKOUT_ERRORS.STRIPE_REDIRECT);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!stepErrorMessageObject.global) return <></>;

  return (
    <div className="mb-6">
      <InlineNotification type="error">
        {stepErrorMessageObject.global}
      </InlineNotification>
    </div>
  );
}
